import adminInitializeBlock from './admin-initialize-block';

const loadBlock = ( initBlock, blockName, blockSelector, resizeInitBlock = false, readyInitBlock = false ) => {
	if ( window.acf ) {
		window.acf.addAction( 'ready', function() {
			if ( window.acf.isGutenberg() ) {
				window.acf.addAction(
					'render_block_preview/type=' + blockName,
					adminInitializeBlock( initBlock, blockSelector )
				);
			}
		} );
	} else {	
		const initializeBlock = function()  {
			let $blockSections = $( blockSelector );

			if ( $blockSections.length ) {
				$blockSections.each( function() {
					initBlock( $( this ) );				
				} );

				return;
			}

			initBlock( $( blockSelector ) );			
		};

		$( document ).ready( function() {
			if ( readyInitBlock && typeof readyInitBlock === 'function' ) {
				readyInitBlock();
				return false;
			}
			
			initializeBlock();
		} );

		$( window ).on( 'resize', function() {
			if ( resizeInitBlock && typeof resizeInitBlock === 'function' ) {
				resizeInitBlock();
				return;
			}
			
			initializeBlock();
		} );		
	}
};

export default loadBlock;